import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'

class MagstimTableDataPatientMedication extends MagstimTableData {

    getNamedValuePairs(data) {

        let tableData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        tableData = [
            { name: CurrentLang().edit_patient_medication_label, value: StringUtils.formatStringOrNoData(data.Name, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_dosage_label, value: StringUtils.formatStringOrNoData(data.Dosage, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_unit_label, value: StringUtils.formatStringOrNoData(data.Units, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_frequency_label, value: StringUtils.formatStringOrNoData(data.Frequency, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_effective_date_label, value: StringUtils.formatUtcDateOrNoData(data.EffectiveDate, CurrentLang().no_data) }, 
        ]
 
        return tableData;
    }
}

export default MagstimTableDataPatientMedication;
